import React, { useEffect, useState } from "react";

export default function AdminReviewsPage() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Cargar reseñas al montar
  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (!token) {
      // 🛑 Si no hay token, redirige al login
      window.location.href = "/admin-login";
      return;
    }

    // 👉 Si hay token, cargar reseñas
    fetchReviews();
  }, []);

  // 🔹 Obtener reseñas de Supabase
  const fetchReviews = async () => {
  setLoading(true);
  const token = localStorage.getItem("adminToken");

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache", // 🚫 evita caché CDN
          Pragma: "no-cache",          // 🚫 HTTP/1.0
        },
        cache: "no-store",             // 🚫 evita usar caché del navegador/CDN
      }
    );

    const data = await res.json();

    if (!res.ok) {
      alert(data.error || "Error obteniendo reseñas");
      return;
    }

    setReviews(data || []);
  } catch (err) {
    console.error("💥 Error:", err);
    alert("Ocurrió un error cargando reseñas.");
  }

  setLoading(false);
};


  // ✅ Aprobar reseña
 const aprobarReseña = async (id) => {
  const token = localStorage.getItem("adminToken");

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews/approve/${id}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      const data = await res.json();
      return alert("Error al aprobar: " + data.error);
    }

    alert("✔️ Reseña aprobada correctamente");

    // 👇 En vez de filtrar manual, volvemos a cargar reseñas.
    fetchReviews(); // 🔄 ACTUALIZA LA TABLA DESDE EL SERVIDOR
  } catch (err) {
    alert("Error al aprobar reseña");
  }
};

  // 🗑️ Eliminar reseña
  const eliminarReseña = async (id) => {
    const token = localStorage.getItem("adminToken");

    try {
      const res = await fetch(
        // ✅ CORREGIDO: USAR /api/admin/reviews/
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) {
        const data = await res.json();
        return alert("Error al eliminar: " + data.error);
      }

      alert("🗑️ Reseña eliminada");
      // Filtra la reseña eliminada de la lista
      setReviews((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      alert("Error al eliminar reseña");
    }
  };

  if (loading)
    return <p style={{ textAlign: "center" }}>Cargando reseñas...</p>;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "30px",
          fontSize: "24px",
          color: "#333",
        }}
      >
        📋 Panel de Reseñas
      </h2>

      {reviews.length === 0 ? (
        <p style={{ textAlign: "center" }}>No hay reseñas pendientes.</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            backgroundColor: "#fafafa",
          }}
        >
          <thead>
            <tr style={{ background: "#f3d8d2", textAlign: "left" }}>
              <th style={{ padding: "10px" }}>Nombre</th>
              <th style={{ padding: "10px" }}>Email</th>
              <th style={{ padding: "10px" }}>Comentario</th>
              <th style={{ padding: "10px" }}>Valoración</th>
              <th style={{ padding: "10px" }}>Aprobada</th>
              <th style={{ padding: "10px" }}>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {reviews.map((r) => (
              <tr key={r.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "10px" }}>{r.nombre}</td>
                <td style={{ padding: "10px" }}>{r.email}</td>
                <td style={{ padding: "10px" }}>{r.comentario}</td>
                <td style={{ padding: "10px" }}>{r.rating} ⭐</td>
                <td style={{ padding: "10px" }}>
                  {r.aprobada ? "✅ Sí" : "❌ No"}
                </td>
                <td style={{ padding: "10px" }}>
                  {!r.aprobada && (
                    <button
                      onClick={() => aprobarReseña(r.id)}
                      style={{
                        background: "#4CAF50",
                        color: "white",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                    >
                      Aprobar
                    </button>
                  )}

                  <button
                    onClick={() => eliminarReseña(r.id)}
                    style={{
                      background: "#E74C3C",
                      color: "white",
                      border: "none",
                      padding: "6px 10px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}